import moment from "moment";

const sFormat = "YYYY-MM-DD";

function ConvertMinutesToMillisSync(nMinutes: number): number {
    return nMinutes * 60 * 1000;
}

function TimeDiffBetweenTwoDatesSync(timeStart: Date, timeEnd: Date) {
    let diffInMilliSeconds = Math.abs(timeEnd.valueOf() - timeStart.valueOf()) / 1000;

    // calculate days
    const days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;

    // calculate hours
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;

    // calculate minutes
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;

    let difference = "";
    if (days > 0) {
        difference += days === 1 ? `${days} day, ` : `${days} days, `;
    }
    if (hours > 0) {
        difference += hours === 1 ? `${hours} hour, ` : `${hours} hours, `;
    }

    difference += minutes === 0 || hours === 1 ? `${minutes} minutes` : `${minutes} minutes`;

    return difference;
}

function GetUTCHourAndMinutesFromDateSync(date: Date) {
    return `${date.getUTCHours()}:${date.getUTCMinutes()}`;
}

function getFirstDateOfCurrentMonth() {
    return moment().startOf("month").format(sFormat);
}

function getFirstDateOfLastMonth() {
    return moment().subtract(1, "months").startOf("month").format(sFormat);
}

function getLastDateOfLastMonth() {
    return moment().subtract(1, "months").endOf("month").format(sFormat);
}

const getComparisonOptionsDates = (start, end) =>{
    const datesRange = {start, end}
    const keyValueDateLabels = { 1: 1, 7: 7, 28: 28};
    Object.entries(keyValueDateLabels).forEach(([key, daysToSubtract]) => {
        datesRange[`${key}`] = moment(datesRange.start).subtract(daysToSubtract, "day").toDate();
    });
    return datesRange
}

const checkIfDateIsInComparisonOptions = (date, comparisonOptions) =>{
    for(const optionalDate of Object.values(comparisonOptions)){
        if(date === optionalDate) return true
    }
    return false
}

export {
    getComparisonOptionsDates,
    checkIfDateIsInComparisonOptions,
    TimeDiffBetweenTwoDatesSync,
    GetUTCHourAndMinutesFromDateSync,
    ConvertMinutesToMillisSync,
    getFirstDateOfLastMonth,
    getFirstDateOfCurrentMonth,
    getLastDateOfLastMonth,

};
